import {CollectionViewer, DataSource} from '@angular/cdk/collections';
import {BehaviorSubject, Observable, of} from 'rxjs';
import {FaxService as FaxApiService} from '../../api/services/fax.service';
import {catchError, finalize} from 'rxjs/operators';
import {FaxModel} from '../../api/models/fax-model';
import {FaxesRequest} from '../../api/models/faxes-request';
import {FaxGridResponse} from '../../api/models/fax-grid-response';


export class FaxDatasource implements DataSource<FaxModel> {

  constructor(private faxApiService: FaxApiService) {
  }

  private dataSubject = new BehaviorSubject<FaxModel[]>([]);
  private dataTotalSubject = new BehaviorSubject<number>(0);
  private loadingSubject = new BehaviorSubject<boolean>(true);

  public loading$ = this.loadingSubject.asObservable();
  public dataCount$ = this.dataTotalSubject.asObservable();

  connect(collectionViewer: CollectionViewer): Observable<FaxModel[] | ReadonlyArray<FaxModel>> {
    console.log('Connecting data source');
    return this.dataSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    console.log('Disconnecting data source');
    this.dataSubject.complete();
    this.loadingSubject.complete();
    this.dataTotalSubject.complete();
  }

  public currentPageData(): FaxModel[] {
    return this.dataSubject.getValue();
  }

  public queryData(state: FaxesRequest): void {
    console.log('query audit items');
    this.loadingSubject.next(true);

    this.faxApiService
      .faxGetGetIncomingFaxes({body: state})
      .pipe(
        catchError(() => of({data: [], total: 0})),
        finalize(() => this.loadingSubject.next(false))
      )
      .subscribe((response: FaxGridResponse) => {
        this.dataTotalSubject.next(response.total);
        this.dataSubject.next(response.data);
      });
  }
}
